export interface ErrorObject {
  [key: string]: ErrorItem[];
}
export interface ErrorItem {
  code: string;
  message: string;
}
interface ErrorObjectString {
  [key: string]: string;
}
export const handle400Error = (backendErrors: ErrorObject, setError: any) => {
  let errors: ErrorObjectString = {};
  for (let key in backendErrors) {
    errors[key] = backendErrors[key].map((e) => e.message).join(' ');
    setError(key, { type: 'custom', message: errors[key] });
  }
};
